import { INCREMENTAL_COUNTER_MAX } from "web_myplann/Shared/constants";
import { parseThousands } from "web_myplann/Shared/Utils/numberFormatters";

export const parseCounterInput = (raw: string) =>
	Math.min(parseThousands(raw) ?? 0, INCREMENTAL_COUNTER_MAX);
